<script>
    import { query, current_result, Filter } from "../stores";

    export let label;
    export let field;

    let isOpen = false;
    let searchText = "";

    $: result_facets = ($current_result.facets && $current_result.facets[field]
        ? $current_result.facets[field].values
        : []).filter(it => it.count > 0 && it.name.trim().length > 0);
    $: facets = searchText.length === 0 ? result_facets : result_facets.filter(it => it.name.toLowerCase().includes(searchText.toLowerCase()));

    function addFilter(facet) {
        query.add(new Filter(facet.name, facet.fq))
    }
</script>

<a on:click={() => isOpen = !isOpen} class="btn btn-filter" href="javascript:void(0);" aria-expanded={isOpen}  role="button">{label}</a>
<div class:collapse={!isOpen}>
    <div class="body-filter">
        <form>
            <div class="form-group">
                <div class="wrap-refine d-flex justify-content-between">
                    <input bind:value={searchText} type="text" class="form-control" id="" placeholder="">
                </div>
            </div>
        </form>
        <ul>
            {#each facets as f}
                <li><a on:click|preventDefault={() => addFilter(f)} href="#n">{f.name}<span>{f.count}</span></a></li>
            {/each}
        </ul>
    </div>
</div>
